<script setup lang="ts">

import {ArrowDownBold, ArrowUpBold} from "@element-plus/icons-vue";

const model = defineModel();
const props = defineProps({
  isOpen: Boolean,
  options: {
    type: Array,
    required: true,
  },
  title: String
});
</script>


<template>
  <div class="flex items-center h-full">
    <el-dropdown
        trigger="click"
        @visible-change="val => isOpen = val"
        :hide-on-click="false"
    >
        <span class="el-dropdown-link flex items-center">
          {{ title }}
          <el-icon class="el-icon--right ml-1">
            <component :is="isOpen ? ArrowUpBold : ArrowDownBold" />
          </el-icon>
        </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item v-for="item in options" :key="item">
            <label class="flex items-center cursor-pointer select-none responsive-body-large text-bw-midGrey ">
              <input
                  type="checkbox"
                  class="cursor-pointer"
                  v-model="model"
                  :value="item"
                  @click.stop
              />
              {{ item }}
            </label>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<style scoped>

</style>
